var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.55554 8.11062C6.55554 8.93574 6.88332 9.72706 7.46676 10.3105C8.05021 10.894 8.84153 11.2217 9.66665 11.2217C10.4918 11.2217 11.2831 10.894 11.8665 10.3105C12.45 9.72706 12.7778 8.93574 12.7778 8.11062C12.7778 7.2855 12.45 6.49418 11.8665 5.91073C11.2831 5.32729 10.4918 4.99951 9.66665 4.99951C8.84153 4.99951 8.05021 5.32729 7.46676 5.91073C6.88332 6.49418 6.55554 7.2855 6.55554 8.11062Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99994 18.9992V17.4436C4.99994 16.6185 5.32772 15.8272 5.91116 15.2437C6.49461 14.6603 7.28593 14.3325 8.11105 14.3325H11.2222C12.0473 14.3325 12.8386 14.6603 13.422 15.2437C14.0055 15.8272 14.3333 16.6185 14.3333 17.4436V18.9992",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1113 5.10107C15.7805 5.27242 16.3736 5.66162 16.7972 6.20731C17.2208 6.75301 17.4507 7.42416 17.4507 8.11496C17.4507 8.80576 17.2208 9.47691 16.7972 10.0226C16.3736 10.5683 15.7805 10.9575 15.1113 11.1288",
    stroke: "#D35258",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 19.0007V17.4451C18.9961 16.7585 18.7651 16.0924 18.343 15.5508C17.9209 15.0091 17.3316 14.6223 16.6667 14.4507",
    stroke: "#D35258",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadOut);
export default __webpack_public_path__ + "static/media/LoadOut.ed48ab00e44ccd61fda0511d38ad184e.svg";
export { ForwardRef as ReactComponent };